<script setup>
import { defineComponent } from 'vue'
import {useRoute} from "vue-router";
import Redirect from "@/components/Redirect.vue";
const route = useRoute()
defineComponent({
  name: 'SuccesAchatNFC',
})
</script>

<template>
  <div class="container text-center">
    <h1 class="py-3 py-sm-5">Merci d'avoir rechargé votre carte</h1>
    <p>Votre commande n° {{route.query.numeroCommande}} a été enregistrée.</p>
    <p>
      Le réseau iSimouv' vous remercie pour votre commande.
      <br>
      Un email vient de vous être envoyé confirmant votre nouvel abonnement.
      <br>
      Bonne route à bord !
      <br><br>
      Agence iSimouv'
      <br>
      1 Rue de la Gare
      <br>
      57400 Sarrebourg
      <br>
      Téléphone : 0 800 71 06 36
      <br>
      E-mail : <a href="mailto:contact@isimouv.fr">contact@isimouv.fr</a>
    </p>
    <Redirect/>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/main";

</style>
